function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 60 60"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#639"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51 12.2c0-.9-.3-1.6-.9-2.2-.7-.7-1.4-1-2.3-1H12.2c-.9 0-1.6.3-2.2 1-.7.6-1 1.3-1 2.2v35.6c0 .9.3 1.6.9 2.2s1.3.9 2.2.9H40l11-12.7zm-41.3 0c0-.7.2-1.3.7-1.7.5-.5 1.1-.7 1.7-.7h35.6c.7 0 1.3.2 1.7.7.5.5.7 1.1.7 1.7v6.2H9.7zM39 50.3H12.2c-.7 0-1.3-.2-1.7-.7-.5-.5-.7-1.1-.7-1.7V19.1h40.6v18.1h-8.1c-.9 0-1.6.3-2.2.9s-.9 1.3-.9 2.2v10zm.7.1V40.3c0-.7.2-1.3.7-1.7.5-.5 1.1-.7 1.7-.7h8.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 25.9h21.3v.7H24zm-4.9 2.6V24h-4.4v4.4h4.4zm-3.8-3.8h3.1v3.1h-3.1zm8.7 8.7h11.9v.7H24zM19.1 36v-4.4h-4.4V36zm-3.8-3.8h3.1v3.1h-3.1zm8.7 8.7h10v.7H24zm-4.9 2.6V39h-4.4v4.4h4.4zm-3.8-3.8h3.1v3.1h-3.1z"
})));